import { render, staticRenderFns } from "./AddSavedSearch.vue?vue&type=template&id=0f44b54e&scoped=true"
import script from "./AddSavedSearch.vue?vue&type=script&lang=js"
export * from "./AddSavedSearch.vue?vue&type=script&lang=js"
import style0 from "./AddSavedSearch.vue?vue&type=style&index=0&id=0f44b54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44b54e",
  null
  
)

export default component.exports